export default __webpack_public_path__ + "static/media/dev-box-card-preview-win11.a7f1a825.jpg";